import type { DocumentForm } from './document-form'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { useUploadWithProgress } from '~/hooks/use-upload-with-progress'
import { documentUploadError } from './document-upload-error'

/**
 * Le dépôt d'un document (#326) : le fichier et ses réglages partent ensemble en
 * multipart. Un refus garde le formulaire, pour corriger sans tout reprendre.
 */
export function useDocumentUpload(onUploaded: () => void) {
  const { t } = useTranslation()
  const { state, upload, cancel } = useUploadWithProgress()
  const [error, setError] = useState<string | null>(null)

  const submit = async (file: File, form: DocumentForm) => {
    setError(null)
    const body = new FormData()
    body.append('title', form.title)
    if (form.sessionId) body.append('sessionId', form.sessionId)
    body.append('requiredBeforeStart', String(form.requiredBeforeStart))
    body.append('file', file)

    const outcome = await upload('/documents', body)
    if (outcome.kind === 'cancelled') return
    const cause = documentUploadError(outcome)
    if (cause) {
      setError(t(cause))
      return
    }
    toast.success(t('documents.uploaded'))
    onUploaded()
  }

  return { state, submit, cancel, error, busy: state.phase !== 'idle' }
}
